"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = extractAssetsFromMap;

function assetIdExists(ids, asset) {
  return !!ids && (!(null !== asset) || void 0 !== asset && ids.includes(asset.assetId));
}

function extractAssetsFromMap(assetMap, ids) {
  var mapArray = Array.from(assetMap.values());
  return mapArray.filter(function (asset) {
    return assetIdExists(ids, asset);
  });
}